import { Link, LinkProps } from 'react-router-dom';

export const LinkOrScroll = (props: LinkProps & React.RefAttributes<HTMLAnchorElement>) => {
    const to = props.to.toString()
    if (to.indexOf('/contact/') === 0 || to.indexOf('/web-prob/') === 0) {
        // eslint-disable-next-line jsx-a11y/anchor-has-content
        return <a href={to} {...props} />
    }
    return <Link {...props} data-hashlink={to.indexOf('#') === 0} data-pagetop={to === '#'} />
}
